import { t } from "i18next";

const MemberFamily = (props) => {
    const { items, addRows, removeRows, updateState } = props;
    return (
        items.map((item, idx) => (
            idx == 0 ?
                <div className="row" key={idx}>
                    <div className="col-md-6 form-group mb-1-5">
                        <label>{t('son_daughter')}</label>
                        <div className="d-flex familyinfo">
                            <select className="form-control searchDropdown" value={item.type} style={{ width: "200px" }} index={idx} name="type" onChange={(e) => updateState(e)}>
                                <option value="">{t('choose')}</option>
                                <option value="Son">{t('son')}</option>
                                <option value="Daughter">{t('daughter')}</option>
                            </select>
                            <input type="text" className="form-control" placeholder={t('enter_name')} index={idx} name="name" onChange={(e) => updateState(e)} value={item.name} autoComplete="off"/>
                        </div>
                    </div>
                    <div className="col-md-6 form-group mb-1-5">
                        <label>{t('dob')}</label>
                        <input type="date" className="form-control" index={idx} name="dob" onChange={(e) => updateState(e)} value={item.dob}/>

                        <button className="btn btn-link addMore float-end pe-0" type="button" onClick={addRows}>{t('add_more')}</button>
                    </div>
                </div>
                :
                <div className="row" key={idx}>
                    <div className="col-md-6 form-group mb-1-5">
                        <label>{t('son_daughter')}</label>
                        <div className="d-flex familyinfo">
                            <select className="form-control searchDropdown" value={item.type} style={{ width: "200px" }} index={idx} name="type" onChange={(e) => updateState(e)}>
                                <option value="">{t('choose')}</option>
                                <option value="Son">{t('son')}</option>
                                <option value="Daughter">{t('daughter')}</option>
                            </select>
                            <input type="text" className="form-control" placeholder="Enter name" index={idx} name="name" onChange={(e) => updateState(e)} value={item.name} autoComplete="off"/>
                        </div>
                    </div>
                    <div className="col-md-6 form-group mb-1-5">
                        <label>{t('dob')}</label>
                        <input type="date" className="form-control" index={idx} name="dob" onChange={(e) => updateState(e)} value={item.dob}/>

                        <button className="btn btn-link float-end pe-0" type="button" onClick={e => removeRows(idx)}>{t('remove')}</button>
                    </div>
                </div>
        ))
    );
}

export default MemberFamily;